import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';

export interface EthereumPrepareStakingInfo {
  count: number;
  withdrawaddr: string;
  claimaddr: string;
  pubkeys: string[];
  signatures: string[];
  paramsSig: string;
  extradata: number;
  tips: number;
  stake: number;
}

export const deleteOrder_mutationFn = (variables: { paramsSig: string }) => {
  return request.post<ResponseObject<EthereumPrepareStakingInfo>>(
    '/api/v1/eth2/order/delete/batch',
    {
      paramsSigs: [variables.paramsSig],
    }
  );
};
